/** Fixed rail + matched line-height — everything centers inside the same 20px row. */
export const BREADCRUMB_LIST_CLASSES =
  'flex items-center gap-0 text-sm leading-5 max-w-full overflow-hidden';

export const BREADCRUMB_SEGMENT_LI_CLASSES = 'flex h-5 min-w-0 items-center';

export const BreadcrumbChevron = () => (
  <span className="flex h-5 w-4 shrink-0 items-center justify-center px-1" aria-hidden="true">
    <svg
      fill="none"
      overflow="visible"
      shapeRendering="geometricPrecision"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.125"
      viewBox="9 6 6 12"
      className="pointer-events-none block h-3 w-1.5 shrink-0"
    >
      <path d="M9 18l6-6-6-6" />
    </svg>
  </span>
);
